import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import VueNotify from 'vue-notifyjs'
import VueMeta from 'vue-meta'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import security from '@/services/security.js'
import VueHtmlToPaper from 'vue-html-to-paper'
import PaperDashboard from '@/plugins/paper-dashboard/paper-dashboard.js'
import AppLayout from '@/layouts/app/app-layout.vue'
import BrochureLayout from '@/layouts/brochure/brochure-layout.vue'
import ElementUI from '@/plugins/element-ui.js'
import VueNow from '@/plugins/vue-now/index.js'
import VueAnalytics from 'vue-analytics'

import Breakpoints from '@/services/breakpoints.js'

import '@/assets/sass/paper-dashboard.scss'
import '@/assets/bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/css/two-beads.css'

// local
// axios.defaults.baseURL = 'https://localhost:44362'
// beta
// axios.defaults.baseURL = 'https://beta-two-beads-api.azurewebsites.net'
// demo
// axios.defaults.baseURL = 'https://demo-two-beads-api.azurewebsites.net'
// www
axios.defaults.baseURL = 'https://www-two-beads-api.azurewebsites.net'

axios.defaults.headers.post['Content-Type'] = 'application/json'

Vue.config.productionTip = false

var htmlToPaperOtions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=yes'
  ]
}
Vue.use(VueHtmlToPaper, htmlToPaperOtions)
Vue.use(VueAnalytics, {
  id: 'UA-187636659-1',
  router
})
Vue.use(PaperDashboard)
Vue.use(ElementUI)
Vue.use(VueNow)
Vue.use(VueMeta)
Vue.use(VueNotify, { type: 'success', timeout: 2000, horizontalAlign: 'center' })
Vue.component('app-layout', AppLayout)
Vue.component('brochure-layout', BrochureLayout)

new Vue({
  router,
  store,
  data: {
    courseKey: null,
    courseName: null,
    courseStatus: null,
    userFullName: null,
    userFirstName: null,
    userLastName: null,
    courses: null,
    courseScouterType: null,
    scouterKey: null,
    isAdmin: null,
    isCourseDirector: null,
    isLoggedIn: false,
    bstrap: require('bootstrap/dist/css/bootstrap.css'),
    breakpoints: {
      xs: null
    },
    version: '0.12.1.w'
  },
  created: function () {
    security.teardownVueSession(this.$root)
    this.breakpoints = new Breakpoints()
  },
  methods: {
  },
  render: h => h(App)
}).$mount('#app')
